/* @flow */
import cx from 'classnames';
import React from 'react';
import type { Attendance } from 'entities/ActivityRecipient';

import styles from './styles/EventRSVPForm.css';

type Props = {
  onChange: ?(attendance: Attendance) => void,
  initialResponse?: ?Attendance,
  disableSelectionChange?: boolean,
  buttonSize?: 'small' | 'medium',
  className?: ?string,
};

type State = {
  selectedResponse: ?Attendance
};

class EventRSVPForm extends React.Component {
  props: Props;

  state: State = {
    selectedResponse: this.props.initialResponse,
  };

  static defaultProps = {
    disableSelectionChange: false,
    buttonSize: 'small',
  }

  componentWillUpdate(nextProps: Props) {
    if (nextProps.initialResponse && this.props.initialResponse !== nextProps.initialResponse) {
      this.setState({ selectedResponse: nextProps.initialResponse });
    }
  }

  getClassNames(response: Attendance) {
    const isSelected = this.state.selectedResponse === response;

    let buttonStyle = styles.mediumButton;
    if (this.props.buttonSize === 'small') {
      buttonStyle = styles.smallButton;
    }

    return cx(styles.button, buttonStyle, { [styles.selected]: isSelected });
  }

  changeResponse(selectedResponse: Attendance) {
    if (this.props.disableSelectionChange) {
      if (this.props.onChange) {
        this.props.onChange(selectedResponse);
      }
      return;
    }

    this.setState({ selectedResponse }, () => {
      if (this.props.onChange) {
        this.props.onChange(selectedResponse);
      }
    });
  }

  render() {
    return (
      <div className={cx(styles.this, this.props.className)}>
        <div className={styles.buttonGroup}>
          <div
            className={this.getClassNames('yes')}
            onClick={() => this.changeResponse('yes')} >
            Yes
          </div>

          <div
            className={this.getClassNames('maybe')}
            onClick={() => this.changeResponse('maybe')}>
            Maybe
          </div>

          <div
            className={this.getClassNames('no')}
            onClick={() => this.changeResponse('no')}>
            No
          </div>
        </div>
      </div>
    );
  }
}

export default EventRSVPForm;



// WEBPACK FOOTER //
// ./src/payments/components/EventRSVPForm.jsx